(function(){
  'use strict';
  if(window.__hwUx)return;window.__hwUx=true;
  var cfg=window.hwConfig||{};
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn)}
  function money(c){try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:cfg.currency||'USD'}).format(c/100)}catch(e){return '$'+(c/100).toFixed(2)}}

  ready(function(){
    document.body.classList.add('hw-loaded');
    var bar=document.createElement('div');bar.className='hw-progress';document.body.appendChild(bar);
    var top=document.createElement('button');top.className='hw-top';top.type='button';top.setAttribute('aria-label','Back to top');
    top.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    document.body.appendChild(top);
    top.addEventListener('click',function(){window.scrollTo({top:0,behavior:reduce?'auto':'smooth'})});
    var ticking=false;
    function onScroll(){
      if(ticking)return;ticking=true;
      requestAnimationFrame(function(){
        var h=document.documentElement,max=h.scrollHeight-h.clientHeight,y=h.scrollTop||document.body.scrollTop;
        bar.style.width=(max>0?(y/max*100):0)+'%';
        top.classList.toggle('on',y>600);
        ticking=false;
      });
    }
    window.addEventListener('scroll',onScroll,{passive:true});onScroll();

    if(!reduce&&window.matchMedia('(pointer:fine)').matches){
      var hero=document.querySelector('.hw-hero');
      if(hero){
        var moon=hero.querySelector('.hw-moon'),ph=hero.querySelector('.hw-hero-media .ph');
        hero.addEventListener('mousemove',function(e){
          var r=hero.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;
          if(moon)moon.style.transform='translate('+(x*-18)+'px,'+(y*-14)+'px)';
          if(ph)ph.style.transform='scale(1.06) translate('+(x*-10)+'px,'+(y*-8)+'px)';
        });
        hero.addEventListener('mouseleave',function(){if(moon)moon.style.transform='';if(ph)ph.style.transform=''});
      }
    }

    if(cfg.deadline){
      var t=Date.parse(cfg.deadline);
      [].slice.call(document.querySelectorAll('.tmc-announce__msg')).forEach(function(n){if(n.textContent.indexOf('{countdown}')>-1)n.innerHTML=n.innerHTML.replace('{countdown}','<span class="hw-cd">--</span>')});
      var cds=document.querySelectorAll('.hw-cd');
      if(!isNaN(t)&&cds.length){
        var pad=function(n){return(n<10?'0':'')+n};
        var tick=function(){
          var d=t-Date.now(),s;
          if(d<=0)s='CLOSED';
          else{var days=Math.floor(d/864e5),h=Math.floor(d/36e5)%24,m=Math.floor(d/6e4)%60,sec=Math.floor(d/1e3)%60;s=(days>0?days+'D ':'')+pad(h)+':'+pad(m)+':'+pad(sec)}
          for(var i=0;i<cds.length;i++)cds[i].textContent=s;
        };
        tick();setInterval(tick,1000);
      }
    }

    var info=document.querySelector('.product__info-container');
    var form=document.querySelector('product-form form, form[data-type="add-to-cart-form"]');
    var submit=form&&form.querySelector('.product-form__submit');
    if(submit&&info){
      var titleEl=document.querySelector('.product__title h1, .product__title h2'),img=document.querySelector('.product__media img');
      var src=img?(img.currentSrc||img.src):'';
      var bar2=document.createElement('div');bar2.className='hw-sticky';
      bar2.innerHTML=(src?'<img src="'+src+'" alt="">':'')+'<div class="t"><b>'+(titleEl?titleEl.textContent.trim():'')+'</b><span></span></div><button type="button">Add to bag</button>';
      document.body.appendChild(bar2);document.body.classList.add('hw-sticky-on');
      var sb=bar2.querySelector('button'),sp=bar2.querySelector('.t span');
      function sync(){
        var p=info.querySelector('.price .price-item--sale')||info.querySelector('.price .price-item--regular');
        if(p){
          var was=p.querySelector('s'),now=p.querySelector('.tmc-now');
          sp.replaceChildren();
          if(was&&now){
            var oldPrice=document.createElement('s'),currentPrice=document.createElement('strong');
            oldPrice.textContent=was.textContent.trim();
            currentPrice.textContent=now.textContent.trim();
            sp.appendChild(oldPrice);
            sp.appendChild(document.createTextNode(' '));
            sp.appendChild(currentPrice);
          }else{
            sp.textContent=p.textContent.trim();
          }
        }
        var dis=submit.disabled||submit.getAttribute('aria-disabled')==='true';
        sb.disabled=dis;sb.textContent=dis?(submit.textContent.trim()||'Sold out'):'Add to bag';
      }
      sync();new MutationObserver(sync).observe(info,{subtree:true,childList:true,attributes:true,characterData:true});
      sb.addEventListener('click',function(){submit.click()});
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(en){bar2.classList.toggle('on',!en[0].isIntersecting&&en[0].boundingClientRect.top<0)},{threshold:0}).observe(submit);
      }
    }

    var thr=parseInt(cfg.freeShipping,10)||0;
    if(thr>0){
      var thrC=thr*100;
      var render=function(total){
        [document.querySelector('cart-drawer .drawer__footer'),document.querySelector('.cart__footer .cart__blocks')].forEach(function(h){
          if(!h)return;
          var el=h.querySelector('.hw-ship');
          if(!el){el=document.createElement('div');el.className='hw-ship';el.innerHTML='<p></p><div class="bar"><i></i></div>';h.insertBefore(el,h.firstChild)}
          var p=el.querySelector('p'),i=el.querySelector('i');
          i.style.width=Math.min(100,total/thrC*100)+'%';
          if(total>=thrC){p.className='ok';p.innerHTML='<b>You unlocked free shipping</b>'}
          else{p.className='';p.innerHTML='Add <b>'+money(thrC-total)+'</b> more for free shipping'}
        });
      };
      var refresh=function(){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){render(c.total_price)}).catch(function(){})};
      refresh();
      var cd=document.querySelector('cart-drawer');
      if(cd){new MutationObserver(function(){if(!cd.querySelector('.hw-ship'))refresh()}).observe(cd,{childList:true,subtree:true})}
      document.addEventListener('cart:refresh',refresh);
      var of=window.fetch;
      window.fetch=function(){var p=of.apply(this,arguments);try{var u=arguments[0];u=typeof u==='string'?u:(u&&u.url)||'';if(/\/cart\/(add|change|update)/.test(u))p.then(function(){setTimeout(refresh,300)})}catch(e){}return p};
    }
  });
})();
